const mockArtistWishlistData = [
    {
        "id": 30,
        "name": "Choker",
        "spotify_identifier": "5XQRfs0gXs30aWUn1Umves",
        "popularity": 40,
        "followers": 207415,
        "image_big": "https://i.scdn.co/image/ab6761610000e5ebffe85bf878eff2bd2ffe7003",
        "image_small": "https://i.scdn.co/image/ab6761610000f178ffe85bf878eff2bd2ffe7003"
    },
    {
        "id": 38,
        "name": "Gary Beck",
        "spotify_identifier": "1mUVjZFnDM8mHpi4fR2bPC",
        "popularity": 22,
        "followers": 23497,
        "image_big": "https://i.scdn.co/image/ab6761610000e5eb9c3521923a4ca09888f57376",
        "image_small": "https://i.scdn.co/image/ab6761610000f1789c3521923a4ca09888f57376"
    },
    {
        "id": 21,
        "name": "Hidden Empire",
        "spotify_identifier": "44Ga1YqZthFOzZSTHiNWkC",
        "popularity": 38,
        "followers": 52096,
        "image_big": "https://i.scdn.co/image/ab6761610000e5ebb58baaea4c34c518a879fd0e",
        "image_small": "https://i.scdn.co/image/ab6761610000f178b58baaea4c34c518a879fd0e"
    },
    {
        "id": 15,
        "name": "Layton Giordani",
        "spotify_identifier": "7mC3RkNNTV6p2j9w4F8Ip4",
        "popularity": 46,
        "followers": 65594,
        "image_big": "https://i.scdn.co/image/ab6761610000e5eb0c06ffa45bfc4f38e68d82fc",
        "image_small": "https://i.scdn.co/image/ab6761610000f1780c06ffa45bfc4f38e68d82fc"
    },
    {
        "id": 9,
        "name": "MaX (italy)",
        "spotify_identifier": "5qqCezXCbwvs1gR73rSG6q",
        "popularity": 3,
        "followers": 199,
        "image_big": "https://i.scdn.co/image/ab6761610000e5eb9252757b90ed1422a982e2a2",
        "image_small": "https://i.scdn.co/image/ab6761610000f1789252757b90ed1422a982e2a2"
    },
    {
        "id": 25,
        "name": "Pan-Pot",
        "spotify_identifier": "6OQOvP7RAdmAKVXXQqD0Se",
        "popularity": 38,
        "followers": 212830,
        "image_big": "https://i.scdn.co/image/ab6761610000e5eb6296974dff84d96dc3cc2eee",
        "image_small": "https://i.scdn.co/image/ab6761610000f1786296974dff84d96dc3cc2eee"
    },
    {
        "id": 17,
        "name": "Pig&Dan",
        "spotify_identifier": "04jj7dljPI0ixtNsz2pXWK",
        "popularity": 37,
        "followers": 87596,
        "image_big": "https://i.scdn.co/image/ab6761610000e5eb9932785bb85fc6e240ed8807",
        "image_small": "https://i.scdn.co/image/ab6761610000f1789932785bb85fc6e240ed8807"
    },
    {
        "id": 16,
        "name": "Thomas Schumacher",
        "spotify_identifier": "7KkV7dFoGEXr4M3fpb1FgD",
        "popularity": 44,
        "followers": 81163,
        "image_big": "https://i.scdn.co/image/ab6761610000e5ebd3713af2b04b0378e83efd05",
        "image_small": "https://i.scdn.co/image/ab6761610000f178d3713af2b04b0378e83efd05"
    },
    {
        "id": 23,
        "name": "UMEK",
        "spotify_identifier": "5Hini2nQyoglzpdKe41cZt",
        "popularity": 44,
        "followers": 163124,
        "image_big": "https://i.scdn.co/image/ab6761610000e5ebd688cd14ec7394c778e2c2c6",
        "image_small": "https://i.scdn.co/image/ab6761610000f178d688cd14ec7394c778e2c2c6"
    },
    {
        "id": 26,
        "name": "Veeshy",
        "spotify_identifier": "4I9gvXHCMWMzarL8yOyjIL",
        "popularity": 25,
        "followers": 1841,
        "image_big": "https://i.scdn.co/image/ab6761610000e5eb5e9f9cb0b53c714fb5c8f8bd",
        "image_small": "https://i.scdn.co/image/ab6761610000f1785e9f9cb0b53c714fb5c8f8bd"
    }
]
export default mockArtistWishlistData;